import React, {useState, useEffect} from "react";
import { useNavigate,useSearchParams} from 'react-router-dom';
import moment from 'moment';
import {  Table, Spin, Input, Tooltip, Button } from 'antd';
import { ArrowRightOutlined,StarFilled,SearchOutlined,FilterFilled} from '@ant-design/icons';
import { FaAngleDoubleLeft } from "react-icons/fa";
import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const PipelineDrilldown = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const quality = searchParams.get('quality');
  const type = searchParams.get('type');

  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  const [loading, setLoading] = useState(true)
  const [leadData, setLeadData] = useState([])
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setLoading(true)
    getLeadDetails()
  }, [local_selectedVenueId]); 

  const getLeadDetails = () => {
    getData(`/sales/get_lead_data_by_type/?venue_id=${local_selectedVenueId}&city_id=${local_city}&quality=${quality}&type=${type}`)
    .then(response =>{
      setLeadData(response.results)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const filteredData = leadData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchText.toLowerCase())
    )
  );

  const getSearchColumnConfig = (dataIndex, title) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8, width: 204 }}>
        <Input
          autoFocus
          placeholder={`Search ${title}`}
          value={selectedKeys[0]}
          onChange={(e) => {
            const value = e.target.value;
            setSelectedKeys(value ? [value] : []);
          }}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            type="primary"
            size="small"
            style={{width:90,display:'flex',alignItems:'center'}}
            onClick={() => confirm()}
            icon={<SearchOutlined />}
          >
            Search
          </Button>
          <Button
            type="secondary"
            size="small"
            style={{width:90}}
            onClick={() => {
              clearFilters && clearFilters();
              confirm();
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      return record[dataIndex]?.toLowerCase().includes(value.toLowerCase());
    },
  });

  const getDropdownFilterConfig = (dataIndex, data) => ({
    filters: Array.from(
      new Set(
        data
          .map(item => item[dataIndex])
          .filter(value => value && value.trim() !== '')
      )
    ).map(value => ({
      text: value,
      value: value,
    })),
    onFilter: (value, record) => record[dataIndex] === value,
    filterIcon: (filtered) => (
      <FilterFilled style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
  });

  const columns = [
    {
      title: 'Name',
      dataIndex: 'display_name',
      align: 'center',
      ...getSearchColumnConfig('display_name','Name')
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile_no',
      align: 'center',
      ...getSearchColumnConfig('mobile_no','Mobile')
    },
    {
      title: 'Follow Up-Date',
      dataIndex: 'follow_up_date',
      align: 'center',
      onHeaderCell: () => ({
        style: { whiteSpace: 'nowrap' }
      }),
      render: (value) => {
        return moment(value).format('MMM DD,YYYY')
      },
      sorter: (a, b) => {
        return new Date(a.follow_up_date) - new Date(b.follow_up_date);
      },
    },
    {
      title: 'Venue',
      dataIndex: 'venue',
      key:'venue',
      align: 'center',
      ...getDropdownFilterConfig('venue', leadData),
    },
    {
      title: 'Source',
      dataIndex: 'source',
      key:'source',
      align: 'center',
      ...getDropdownFilterConfig('source', leadData),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key:'status',
      align: 'center',
      ...getDropdownFilterConfig('status', leadData),
      render: (value) => {
        return(
          <div>
          {
            value == 'Response' ?
              <div className='statusColumn' style={{backgroundColor:'#3cb371'}}>
                Response
              </div>
            :
            value == 'Contact Later' ?
              <div className='statusColumn' style={{backgroundColor:'#bdb76b'}}>
                Contact Later
              </div>
            :
            value == 'Demo Scheduled' ?
              <div className='statusColumn' style={{backgroundColor:'#cd853f'}}>
                Demo Scheduled
              </div>
            :
            value == 'Did Not Demo' ?
              <div className='statusColumn' style={{backgroundColor:'#f08080'}}>
                Did Not Demo
              </div>
            :
            value == 'Verbal Confirmation' ?
              <div className='statusColumn' style={{backgroundColor:'#4682b4'}}>
                Verbal Confirmation
              </div>
            :
            value == 'Demo Attended' ?
              <div className='statusColumn' style={{backgroundColor:'#66cdaa'}}>
                Demo Attended
              </div>
            :null
          }
          </div>
          )
      },
    },
    {
      title: 'Quality',
      dataIndex: 'quality',
      align: 'center',
      render: (value) => {
        return(
          <div>
          {
            value == 'Sure Payment' ?
              <div style={{display:'flex',flexDirection:'row'}}>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
              </div>
            :
            value == 'Highly Likely' ?
              <div style={{display:'flex',flexDirection:'row'}}>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
              </div>
            :
            value == 'May Pay' ?
              <div style={{display:'flex',flexDirection:'row'}}>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
              </div>
            :
            value == 'No Response' ?
              <div style={{display:'flex',flexDirection:'row'}}>
                <StarFilled style={{color: 'orange'}}/>
                <StarFilled style={{color: 'orange'}}/>
              </div>
            :
            value == 'Will Not Pay' && 
              <div style={{display:'flex',flexDirection:'row'}}>
                <StarFilled style={{color: 'orange'}}/>
              </div>
          }
          </div>
          )
      },
    },
    {
      title: 'Comment',
      dataIndex: 'comment',
      align: 'center',
    },
    {
      title: '',
      dataIndex: 'empty',
    },
  ]

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>

        <Styled.Header active={true}>
          <Tooltip title="Back"><a style={{cursor: 'pointer',color:'#02475c'}} onClick={()=>navigate('/lead-pipeline')}><FaAngleDoubleLeft/> </a></Tooltip>
          <a>Lead Details</a>
          <ReactHTMLTableToExcel
            className="btn btn-sm downloadBtn"
            table="table-for-download"
            filename={'lead-details'}
            sheet={'Lead Details'}
            buttonText="Download"
          />
        </Styled.Header>
        {/*<div style={{width:'100%',display:'flex',justifyContent:'end',padding:'10px 0'}}>
          <Input
            placeholder="Search..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "250px" }}
            allowClear
          />
        </div>*/}
        <div className="recordCount">{filteredData?.length || 0} records</div>
        <Table
          className="drill-down-table table_container"
          rowKey="id"
          columns={columns}
          dataSource={filteredData}
          pagination={{pageSize: 50, showSizeChanger: false}}
        />

        <table id="table-for-download" style={{ display: 'none' }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Mobile</th>
            <th>Follow Up Date</th>
            <th>Venue</th>
            <th>Comment</th>
            <th>Source</th>
            <th>Status</th>
            <th>Quality</th>
          </tr>
        </thead>
        <tbody>
          {leadData.map((lead, index) => (
            <tr key={index}>
              <td>{lead.display_name}</td>
              <td>{lead.mobile_no}</td>
              <td>{moment(lead.follow_up_date).format('MMM DD, YYYY')}</td>
              <td>{lead.venue}</td>
              <td>{lead.comment}</td>
              <td>{lead.source}</td>
              <td>{lead.status}</td>
              <td>{lead.quality}</td>
            </tr>
          ))}
        </tbody>
      </table>

      </Styled.MainContainer>

    </Spin>
  );
}

export default PipelineDrilldown;